<template>
    <div class="pageContent">
      <div :class="page1Menu==1 ? 'page1Title1':'page1Title1-s'" @click="page1Menu=1;vectorManage=false">创建矢量</div>
      <div :class="page1Menu==2 ? 'page1Title2-s':'page1Title2'" @click="page1Menu=2;getVectorLibrary();vectorManage=false">我的矢量</div>
      <!-- 创建矢量 -->
      <div v-if="page1Menu==1">
          <div :class="buttonSelect==1 ? 'page1Button-s':'page1Button'" @click="buttonSelected(1)" style="margin-top: 74px;">
            <img src="~@/assets/newHome/矢量管理/绘制多边形.png" alt="" style="position: absolute;top: 18px;left: 110px;width: 28px;height: 27px;">
            <div class="buttonText1">绘制多边形</div>
            <!-- 完成矢量显示左上角对号 -->
            <img src="~@/assets/newHome/目标提取/已完成.png" alt="" v-if="vectorCeated==1" style="position: absolute;top: -8px;left: -8px;">
          </div>
          <div :class="buttonSelect==2 ? 'page1Button-s':'page1Button'" @click="buttonSelected(2)" style="height: 64px;">
            <img src="~@/assets/newHome/矢量管理/绘制矩形.png" alt="" style="position: absolute;top: 19px;left: 115px;width: 24px;height: 23px;">
            <div class="buttonText1">绘制矩形</div>
            <!-- 完成矢量显示左上角对号 -->
            <img src="~@/assets/newHome/目标提取/已完成.png" alt="" v-if="vectorCeated==2" style="position: absolute;top: -8px;left: -8px;">
          </div>
          <div :class="buttonSelect==3 ? 'page1Button-s':'page1Button'" @click="buttonSelected(3)">
            <img src="~@/assets/newHome/矢量管理/绘制圆形.png" alt="" style="position: absolute;top: 20px;left: 115px;width: 24px;height: 24px;">
            <div class="buttonText1">绘制圆形</div>
            <!-- 完成矢量显示左上角对号 -->
            <img src="~@/assets/newHome/目标提取/已完成.png" alt="" v-if="vectorCeated==3" style="position: absolute;top: -8px;left: -8px;">
          </div>
          <div :class="buttonSelect==4 ? 'page1Button-s':'page1Button'" @click="buttonSelected(4)">
            <img src="~@/assets/newHome/矢量管理/绘制线矢量.png" alt="" style="position: absolute;top: 20px;left: 120px;width: 14px;height: 25px;">
            <div class="buttonText1">绘制线矢量</div>
            <!-- 完成矢量显示左上角对号 -->
            <img src="~@/assets/newHome/目标提取/已完成.png" alt="" v-if="vectorCeated==4" style="position: absolute;top: -8px;left: -8px;">
          </div>
          <div :class="buttonSelect==5 ? 'page1Button-s':'page1Button'" @click="buttonSelected(5)">
            <img src="~@/assets/newHome/矢量管理/选择行政区域.png" alt="" style="position: absolute;top: 23px;left: 117px;width: 21px;height: 20px;">
            <div class="buttonText1">选择行政区(国内)</div>
            <!-- 完成矢量显示左上角对号 -->
            <img src="~@/assets/newHome/目标提取/已完成.png" alt="" v-if="vectorCeated==5" style="position: absolute;top: -8px;left: -8px;">
          </div>
          <div :class="buttonSelect==6 ? 'page1Button-s':'page1Button'" @click="buttonSelected(6)">
            <img src="~@/assets/newHome/矢量管理/上传矢量文件.png" alt="" style="position: absolute;top: 22px;left: 117px;width: 21px;height: 21px;">
            <div class="buttonText1">上传矢量文件</div>
            <!-- 完成矢量显示左上角对号 -->
            <img src="~@/assets/newHome/目标提取/已完成.png" alt="" v-if="vectorCeated==6" style="position: absolute;top: -8px;left: -8px;">
          </div>
          <div v-if="vectorCeated!=0">
            <div class="vectorLine"></div>
            <div class="buttonSave" @click="tip=1">保存至我的矢量</div>
            <div class="buttonDownload" @click="download()">下载</div>
            <div class="buttonDownload" @click="clear()">清除</div>
          </div>
          <!-- 虚拟创建矢量 -->
          <!-- <div class="jiade" @click="vectorConfirm()" v-if="buttonSelect!=0"></div> -->

      </div>
      <!-- 我的矢量 -->
      <div v-if="page1Menu==2">
        <div v-show="tableData.length>0">
          <div class="searchImg">
            <input type="text" class="searchImgText" placeholder="查找矢量" v-model="searchText" @change="searchVector()">
            <!-- <img src="~@/assets/newHome/图源看图/清除搜索内容.png" alt="" v-if="searchClose" style="position: absolute;top: 13px;right: 13px;width: 18px;height: 18px;cursor: pointer;"> -->
            <img src="~@/assets/newHome/矢量管理/搜索.png" alt="" v-if="searchText!=''" @click="queryVectorLibrary(searchText)" style="position: absolute;top: 13px;right: 13px;width: 18px;height: 18px;cursor: pointer;">
          </div>
          <div class="xialaVectorList" id="xialaListId">
            <div class="fileContent" v-if="rskitVector.length>0" @click="openRskit=!openRskit">
              <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹收回.png" alt="" v-if="!openRskit" class="countrySelect2022" style="left: 15px;top: 16px;" >
              <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹打开.png" alt="" v-if="openRskit"  class="countrySelect2022" style="top: 20px;">
              <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 41px;top: 5px;">
              <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/橙色文件夹默认.png" alt="" style="position:absolute;left: 52px;top: 18px;">
              <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/橙色文件夹打开.png" alt="" style="position:absolute;left: 49px;top: 18px;">
              <div class="fileText1" style="top: 15px;" >已用区域矢量</div>
            </div>
            <div v-if="openRskit">
              <div v-for="(item, index) in rskitVector" :key="'a'+index">
                <div :class="rskitVectorSelect[index] ? 'fileContent-s' : 'fileContent'" @click="rskitVectorSelected(index)" v-if="!vectorManage">
                    <img src="~@/assets/newHome/图源看图/单选_未选中.png" alt="" class="countrySelect2022" style="left:47px" v-if="!rskitVectorSelect[index]">
                    <img src="~@/assets/newHome/图源看图/单选_选中.png" alt="" class="countrySelect2022" style="left:47px" v-if="rskitVectorSelect[index]"  >
                    <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 75px;top: 5px;">
                    <img v-if="/Point/i.test(item.shape_type)" src="~@/assets/Laboratory/点.png" style="position:absolute;left: 89px;top: 17px;width: 14px;height: 18px;"/>
                    <img v-if="/Line/i.test(item.shape_type)" src="~@/assets/Laboratory/线.png" style="position:absolute;left: 82px;top: 20px;width: 27px;height: 12px;"/>
                    <img v-if="/Polygon/i.test(item.shape_type)" src="~@/assets/Laboratory/面.png" style="position:absolute;left: 85px;top: 16px;width: 21px;height: 20px;"/>
                    <div class="fileText1" style="left:130px" :title="item.name">{{ item.name}}</div>
                    <img src="~@/assets/newHome/图源看图/拍摄日期.png" alt="" style="position:absolute;left: 130px;top:35px;width: 14px;height: 12px;">
                    <div class="fileText2" style="left:149px">{{ item.create_time.substring(0,10) }}</div>
                    <div style="position:absolute;left: 220px;top:28px;width: 80px;height: 20px;cursor: pointer;" @click="downloadMyVec(item)">
                      <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/下载矢量.png" alt="" style="position:absolute;left: 5px;top:5px;width: 14px;height: 14px;">
                      <div class="fileText2" style="left:25px;top:5px">下载矢量</div>
                    </div>
                </div>
                <!-- 矢量管理模式 -->
                <div :class="rskitVectorSelect[index] ? 'fileContent-s' : 'fileContent'" v-if="vectorManage">
                    <img src="~@/assets/newHome/矢量管理/排序把手.png" alt="" v-if="vectorManage" style="position: absolute;top: 22px;left: 48px;width: 12px;height: 9px;">
                    <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 80px;top: 5px;">
                    <img v-if="/Point/i.test(item.shape_type)" src="~@/assets/Laboratory/点.png" style="position:absolute;left: 94px;top: 17px;width: 14px;height: 18px;"/>
                    <img v-if="/Line/i.test(item.shape_type)" src="~@/assets/Laboratory/线.png" style="position:absolute;left: 87px;top: 20px;width: 27px;height: 12px;"/>
                    <img v-if="/Polygon/i.test(item.shape_type)" src="~@/assets/Laboratory/面.png" style="position:absolute;left: 90px;top: 16px;width: 21px;height: 20px;"/>
                    <div class="fileText1" style="left:135px" :title="item.name" @click="tip=2;indexContent=index;rskitOrOther=1">{{ item.name}}</div>
                    <img src="~@/assets/newHome/图源看图/拍摄日期.png" alt="" style="position:absolute;left: 135px;top:35px;width: 14px;height: 12px;">
                    <div class="fileText2" style="left:154px">{{ item.create_time.substring(0,10) }}</div>

                </div>
              </div>
            </div>
            <div v-for="(item, index) in otherVector" :key="'b'+index">
              <div :class="otherVectorSelect[index] ? 'fileContent-s' : 'fileContent'" @click="otherVectorSelected(index)" v-if="!vectorManage">
                  <img src="~@/assets/newHome/图源看图/单选_未选中.png" alt="" class="countrySelect2022" style="left:13px" v-if="!otherVectorSelect[index]">
                  <img src="~@/assets/newHome/图源看图/单选_选中.png" alt="" class="countrySelect2022" style="left:13px" v-if="otherVectorSelect[index]"  >
                  <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 42px;top: 5px;">
                  <img v-if="/Point/i.test(item.shape_type)" src="~@/assets/Laboratory/点.png" style="position:absolute;left: 56px;top: 17px;width: 14px;height: 18px;"/>
                  <img v-if="/Line/i.test(item.shape_type)" src="~@/assets/Laboratory/线.png" style="position:absolute;left: 49px;top: 20px;width: 27px;height: 12px;"/>
                  <img v-if="/Polygon/i.test(item.shape_type)" src="~@/assets/Laboratory/面.png" style="position:absolute;left: 52px;top: 16px;width: 21px;height: 20px;"/>
                  <div class="fileText1" style="left:102px" :title="item.name">{{ item.name}}</div>
                  <img src="~@/assets/newHome/图源看图/拍摄日期.png" alt="" style="position:absolute;left: 102px;top:35px;width: 14px;height: 12px;">
                  <div class="fileText2" style="left:123px">{{ item.create_time.substring(0,10) }}</div>
                  <div style="position:absolute;left: 220px;top:28px;width: 80px;height: 20px;cursor: pointer;" @click="downloadMyVec(item)">
                    <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/绘制标注工具集/下载矢量.png" alt="" style="position:absolute;left: 5px;top:5px;width: 14px;height: 14px;">
                    <div class="fileText2" style="left:25px;top:5px">下载矢量</div>
                  </div>
              </div>
              <!-- 矢量管理模式 -->
              <!--  draggable="true" @dragstart="dragstart(item)" @dragenter="dragenter(item,$event)"  @dragend="getDragend(otherVector, 'customer', $event)" -->
              <div class="fileContentDrag" v-if="vectorManage">
                  <img src="~@/assets/newHome/矢量管理/排序把手.png" alt="" v-if="vectorManage" style="position: absolute;top: 22px;left: 14px;width: 12px;height: 9px;">
                  <img src="~@/assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 42px;top: 5px;">
                  <img v-if="/Point/i.test(item.shape_type)" src="~@/assets/Laboratory/点.png" style="position:absolute;left: 56px;top: 17px;width: 14px;height: 18px;"/>
                  <img v-if="/Line/i.test(item.shape_type)" src="~@/assets/Laboratory/线.png" style="position:absolute;left: 49px;top: 20px;width: 27px;height: 12px;"/>
                  <img v-if="/Polygon/i.test(item.shape_type)" src="~@/assets/Laboratory/面.png" style="position:absolute;left: 52px;top: 16px;width: 21px;height: 20px;"/>
                  <div class="fileText1" style="left:102px" :title="item.name" @click="tip=2;indexContent=index;rskitOrOther=2">{{ item.name}}</div>
                  <img src="~@/assets/newHome/图源看图/拍摄日期.png" alt="" style="position:absolute;left: 102px;top:35px;width: 14px;height: 12px;">
                  <div class="fileText2" style="left:121px">{{ item.create_time.substring(0,10) }}</div>
                  <img src="~@/assets/newHome/矢量管理/删除矢量.png" alt="" v-if="vectorManage" @click="deleteVector(item,index)" style="position: absolute;top: 18px;right: 20px; width: 16px;height: 16px;">
              </div>
            </div>
          </div>
          <div class="vectorManage" style="bottom:60px;" @click="$router.push('/imageSegmentation')" v-if="!vectorManage">创建影像拆分</div>
          <div class="vectorManage" @click="getVectorLibrary();vectorManage=true;" v-if="!vectorManage">管理我的矢量</div>
          <div class="vectorManage1" @click="saveVectorChange()" v-if="vectorManage">保存</div>
          <div class="vectorManage2" @click="cancelVectorChange()" v-if="vectorManage">取消</div>
        </div>
        <div v-show="tableData.length==0">
          <div class="myData">您暂未创建任何矢量</div>
        </div>
      </div>
      <!-- 保存矢量 -->
      <div class="shadow" v-if="tip==1">
        <div class="shadowContent2">
            <img src="~@/assets/newHome/目标提取/关闭弹窗.png" alt="" @click="tip=0;vectorName='';vectorLength=0" style="position: absolute;right: -55px;cursor: pointer;">
            <div class="shadowTip3Text1">保存至我的矢量</div>
            <input type="text" class="shadowInput" placeholder="请输入矢量名称" maxlength="50" @input="getLength()" v-model="vectorName">
            <div class="shadowTip3Text2">{{ vectorLength }}/50</div>
            <div :class="vectorName.length>0 ? 'shadowTip3Text3':'shadowTip3Text3-s'" @click="saveMyVector()">确定</div>
            <div class="shadowTip3Text3" style="left: 425px;" @click="tip=0;vectorName='';vectorLength=0">取消</div>
        </div>
      </div>
      <!-- 重命名矢量 -->
      <div class="shadow" v-if="tip==2">
        <div class="shadowContent2">
            <img src="~@/assets/newHome/目标提取/关闭弹窗.png" alt="" @click="tip=0;vectorName='';vectorLength=0" style="position: absolute;right: -55px;cursor: pointer;">
            <div class="shadowTip3Text1">重命名矢量</div>
            <input type="text" class="shadowInput" placeholder="请输入矢量名称" maxlength="50" @input="getLength()" v-model="vectorName">
            <div class="shadowTip3Text2">{{ vectorLength }}/50</div>
            <div :class="vectorName.length>0 ? 'shadowTip3Text3':'shadowTip3Text3-s'" @click="renameVector()">确定</div>
            <div class="shadowTip3Text3" style="left: 425px;" @click="tip=0;vectorName='';vectorLength=0">取消</div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import gsap from "gsap";
  import { Vector,Tile } from 'ol/layer';
  import { Polygon, LineString, MultiPolygon,MultiLineString,Point } from 'ol/geom'
  import Feature from 'ol/Feature';
  import { Style, Fill, Stroke, Circle, Text, Circle as CircleStyle, Icon } from 'ol/style'
  export default {
    name: "myVector",
    inject: ["reload"], //调用刷新
    props:['pageMenu'],
    data() {
      return {
        page1Menu:1,
        tip:0,
        buttonSelect:0,
        //矢量是否创建完成
        vectorCeated:0,
        vectorLength:0,
        vectorName:"",
        tableData:[],
        //橙色文件夹
        rskitVector:[],
        //除了套件里的矢量
        otherVector:[],
        searchText:'',
        searchClose:false,
        //橙色文件夹打开
        openRskit:false,
        //橙色里面列表某一项是否选中
        rskitVectorSelect:[],
        //其他矢量是否选中
        otherVectorSelect:[],
        //矢量管理模式
        vectorManage:false,
        oldData: [],
        newData: [],
        //监听绘制进度
        timer: "",
        indexContent:-1,
        rskitOrOther:0,
        //是否查询矢量
        queryVector:false,
        vectorChangeList:[],
      };
    },
    methods: {
      getKey() {
            return localStorage.getItem("token");
      },
      //清空信息
      clear(){
        this.vectorCeated = 0;
        this.buttonSelect = 0;
        clearInterval(this.timer)
        this.$parent.$refs.mainmap.triggerClean()
        this.$parent.$refs.mainmap.isLeftVector = false
        this.$parent.$refs.mainmap.isUploadVector = false
        this.$parent.$refs.mainmap.drawDisabled = false
        let allLayers = this.$parent.$refs.mainmap.map.getLayerGroup().getLayersArray();
        allLayers.forEach(layer => {
          if (layer instanceof Vector && layer.values_.title=='边框') {
            layer.getSource().clear()
          }//清空矢量图层
        })
      },
      buttonSelected(i) {
        if (this.buttonSelect == i&&this.vectorCeated == 0) { //未绘制再点取消绘制
          this.clear()
        }
        else if(this.buttonSelect == i){ //同类型可以绘制多个
          this.$parent.$refs.mainmap.vectorDraw(i)
          this.$parent.$refs.mainmap.drawDisabled = true  //绘制时禁止使用右侧控件
          this.timer = setInterval(() => {
            if (this.$parent.$refs.mainmap.leftdrawFinished) {
              this.vectorConfirm()
              clearInterval(this.timer)
            }
          }, 500);
        }
        else {
          this.clear()
          this.buttonSelect = i
          this.$parent.$refs.mainmap.vectorDraw(i)
          this.$parent.$refs.mainmap.drawDisabled = true  //绘制时禁止使用右侧控件
          this.timer = setInterval(() => {
            if (this.$parent.$refs.mainmap.leftdrawFinished) {
              this.vectorConfirm()
              clearInterval(this.timer)
            }
          }, 500);
        }

      },
      vectorConfirm(){
        this.vectorCeated=this.buttonSelect
      },
      download() {
        this.$parent.$refs.mainmap.downloadShp()
      },
      saveMyVector() {
        this.$parent.$refs.mainmap.addVectorSubmit(this.vectorName)
        this.tip = 0
        this.vectorName=''
        this.vectorLength=0
      },
      getLength(){
        this.vectorLength=this.vectorName.length
      },
      getVectorLibrary(){
        this.clear()
        this.rskitVector=[]
        this.otherVector=[]
        let param=new FormData();
        param.append('pageNum',1);
        param.append('pageSize',1000);
        this.axios
        .post("/map_service_back/vectorLibrary/getVectorLibrary", param,{
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }).then((res) => {
          if (res.data.code==200) {
            this.tableData=res.data.data;
            console.log(this.tableData);
            for(let i=0;i<this.tableData.length;i++){
              if(this.tableData[i].useintiles==1){
                this.rskitVector.push(this.tableData[i])
              }else{
                this.otherVector.push(this.tableData[i])
              }
            }
            for(let i=0;i<this.rskitVector.length;i++){
              this.rskitVectorSelect[i]=false
            }
            for(let i=0;i<this.otherVector.length;i++){
              this.otherVectorSelect[i]=false
            }
            this.getHeight()
            console.log(this.rskitVector);
            console.log(this.otherVector);
          }else {
            alert("获取矢量列表失败，请联系商务经理（0431-86008580）")
          }
        })
      },
      queryVectorLibrary(name){
        console.log(name);
        this.clear()
        this.rskitVector=[]
        this.otherVector=[]
        let param=new FormData();
        param.append('name',name);
        param.append('pageNum',1);
        param.append('pageSize',1000);
        this.axios
        .post("/map_service_back/vectorLibrary/getVectorLibrary", param,{
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }).then((res) => {
          if (res.data.code==200) {
            this.tableData=res.data.data;
            console.log(this.tableData);
            this.otherVector=this.tableData
            for(let i=0;i<this.otherVector.length;i++){
              this.otherVectorSelect[i]=false
            }
            this.getHeight()
          }else {
            alert("获取矢量列表失败，请联系商务经理（0431-86008580）")
          }
        })
      },
      //橙色文件夹单选
      async rskitVectorSelected(index){
        for(let i=0;i<this.rskitVectorSelect.length;i++){
          this.rskitVectorSelect[i]=false
        }
        for(let i=0;i<this.otherVectorSelect.length;i++){
          this.otherVectorSelect[i]=false
        }
        this.rskitVectorSelect[index]=true
        this.$forceUpdate();

        //展示选定的矢量
        let shape = ''
        let param = new FormData();
        param.append('id', this.rskitVector[index].id)
        await this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
          .then((response) => {
            shape = response.data.data.geojson
          })

        let allLayers = this.$parent.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        allLayers.forEach(layer => {
          if (layer instanceof Vector && layer.values_.title=='边框') {
            layer.getSource().clear()
            let geom = JSON.parse(shape)
            let geometry
            if (geom.type=='MultiPolygon') {
              geometry=new MultiPolygon(geom.coordinates)
            }
            if (geom.type == 'Polygon') {
              geometry=new Polygon(geom.coordinates)
            }
            if (geom.type == 'LineString') {
              geometry=new LineString(geom.coordinates)
            }
            if (geom.type == 'MultiLineString') {
              geometry=new MultiLineString(geom.coordinates)
            }
            let feature=new Feature({
              geometry: geometry
            })
            feature.getGeometry().transform('EPSG:4326', this.$parent.mapParams.projection)
            feature.setStyle(() => {
              return new Style({
                //图层样式
                fill: new Fill({
                  color: 'rgba(255, 255, 255, 0)' //填充颜色
                }),
                stroke: new Stroke({
                  color: '#ffcc33', //边框颜色
                  width: 2 // 边框宽度
                }),
                image: new Circle({
                  radius: 7,
                  fill: new Fill({
                    color: '#ffcc33'
                  })
                })
              })
            })
            layer.getSource().addFeature(feature)
            let ext = layer.getSource().getExtent()
            this.$parent.$refs.mainmap.map.getView().fit(ext)
          }
        })
      },
      //其他矢量也单选
      async otherVectorSelected(index){
        for(let i=0;i<this.rskitVectorSelect.length;i++){
          this.rskitVectorSelect[i]=false
        }
        for(let i=0;i<this.otherVectorSelect.length;i++){
          this.otherVectorSelect[i]=false
        }
        this.otherVectorSelect[index]=true
        this.$forceUpdate();

        //展示选定的矢量
        let shape = ''
        let param = new FormData();
        param.append('id', this.otherVector[index].id)
        await this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
          .then((response) => {
            shape = response.data.data.geojson
          })

        let allLayers = this.$parent.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        allLayers.forEach(layer => {
          if (layer instanceof Vector && layer.values_.title=='边框') {
            layer.getSource().clear()
            let geom = JSON.parse(shape)
            let geometry
            if (geom.type=='MultiPolygon') {
              geometry=new MultiPolygon(geom.coordinates)
            }
            if (geom.type == 'Polygon') {
              geometry=new Polygon(geom.coordinates)
            }
            if (geom.type == 'LineString') {
              geometry=new LineString(geom.coordinates)
            }
            if (geom.type == 'MultiLineString') {
              geometry=new MultiLineString(geom.coordinates)
            }
            let feature=new Feature({
              geometry: geometry
            })
            feature.getGeometry().transform('EPSG:4326', this.$parent.mapParams.projection)
            feature.setStyle(() => {
              return new Style({
                //图层样式
                fill: new Fill({
                  color: 'rgba(255, 255, 255, 0)' //填充颜色
                }),
                stroke: new Stroke({
                  color: '#ffcc33', //边框颜色
                  width: 2 // 边框宽度
                }),
                image: new Circle({
                  radius: 7,
                  fill: new Fill({
                    color: '#ffcc33'
                  })
                })
              })
            })
            layer.getSource().addFeature(feature)
            let ext = layer.getSource().getExtent()
            this.$parent.$refs.mainmap.map.getView().fit(ext)
          }

        })
      },
      getHeight(){
        let height = document.documentElement.clientHeight
        height= height-250
        let xialaListId = document.getElementById("xialaListId")
        xialaListId.style.height=height + 'px'
      },
      /** 拖拽开始 */
      dragstart(value) {
        this.oldData = value;
      },
      /** 拖拽进行 */
      dragenter(value) {
          this.newData = value;
      },
      /** 拖拽结束 */
      getDragend(listData) {
        if (this.oldData !== this.newData) {
            let oldIndex = listData.indexOf(this.oldData)
            let newIndex = listData.indexOf(this.newData)
            let newItems = [...listData];
            console.log(oldIndex);
            console.log(newIndex);
            console.log(newItems);
            // 删除之前DOM节点
            newItems.splice(oldIndex, 1);
            // 在拖拽结束目标位置增加新的DOM节点
            newItems.splice(newIndex, 0, this.oldData);
            // 每次拖拽结束后，将拖拽处理完成的数据，赋值原数组，使DOM视图更新，页面显示拖拽动画
            this.otherVector = newItems;
            console.log( this.otherVector);
            // 每次拖拽结束后调用接口时时保存数据
        }
      },
      renameVector(){
        if(this.vectorName.length>0){
          let id =''
          if(this.rskitOrOther==1){
            this.rskitVector[this.indexContent].name=this.vectorName
            id = this.rskitVector[this.indexContent].id
          }else if(this.rskitOrOther==2){
            this.otherVector[this.indexContent].name=this.vectorName
            id = this.otherVector[this.indexContent].id
          }
          var vectorInfo = {
            id: id,
            name: this.vectorName,
            delete_status: 0,
          }
          this.vectorChangeList.push(vectorInfo)
          this.tip=0
          this.vectorName=''
          this.vectorLength=0
          this.rskitOrOther=0
          this.indexContent=-1
          }
      },
      saveVectorChange(){
        this.axios.post("/map_service_back/vectorLibrary/updateVectors",this.vectorChangeList, {
          headers: {
          Authorization: "Bearer " + this.getKey(),
          },
        }).then((res)=>{
            this.vectorManage=false
            if(res.data.code==200){
              this.getVectorLibrary()
              this.vectorChangeList=[]
            }else{
              alert("保存失败！请联系商务经理（0431-86008580）")
            }

        })
      },
      cancelVectorChange(){
        this.getVectorLibrary()
        this.vectorChangeList=[]
        this.vectorManage=false
      },
      searchVector(){
        this.$nextTick(() => {
          if(this.searchText!=''){
            this.queryVectorLibrary(this.searchText)
          }else{
            this.getVectorLibrary()
          }
        },1000);

      },
      deleteVector(item,index){
        var vectorInfo = {
          id: item.id,
          name:item.name,
          delete_status: 1,
        }
        this.vectorChangeList.push(vectorInfo)
        this.otherVector.splice(index,1)
        console.log(this.otherVector);
      },
      //下载矢量库中的矢量
      async downloadMyVec(vec){
        let shape = ''
        let param = new FormData();
        param.append('id', vec.id)
        await this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
          .then((response) => {
            shape = response.data.data.geojson
          })
        let geom = JSON.parse(shape)
        let geometry
        if (geom.type == 'MultiPolygon') {
          geometry = new MultiPolygon(geom.coordinates)
        }
        if (geom.type == 'Polygon') {
          geometry = new Polygon(geom.coordinates)
        }
        if (geom.type == 'LineString') {
          geometry = new LineString(geom.coordinates)
        }
        if (geom.type == 'MultiLineString') {
          geometry = new MultiLineString(geom.coordinates)
        }
        let feature = new Feature({
          geometry: geometry
        })
        feature.getGeometry().transform('EPSG:4326', this.$parent.mapParams.projection)
        this.$parent.$refs.mainmap.downloadMyShp(feature)

      }

    },
    mounted() {
      if(this.pageMenu==2){
        this.page1Menu=2
        this.getVectorLibrary()
      }else{
        this.page1Menu=1
      }
      this.vectorManage=false
    },
    watch:{
      searchText: function (val) {
        if(val==''){
          this.getVectorLibrary()
        }
      }
    },
    destroyed(){
      clearInterval(this.timer)
      this.clear()
      }
  }
  </script>
  <style scoped>
  .jiade{
    position: fixed;
    top: 300px;
    left: 800px;
    width: 100px;
    height: 100px;
    border: 2px solid pink;
    cursor: pointer;
  }
 .pageContent{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 405px;
    height:calc(100vh);
    background: #2A2A2A;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .page1Title1{
    position: absolute;
    top: 0;
    left: 0;
    width: 202px;
    height: 53px;
    background: #233242;
    border-right:  1px solid rgba(255,255,255,0.25);
    border-bottom:  1px solid rgba(255,255,255,0.25);
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 53px;
    text-align: center;
  }
  .page1Title1-s{
    position: absolute;
    top: 0;
    left: 0;
    width: 202px;
    height: 53px;
    background: #2A2A2A;
    border-right:  1px solid rgba(255,255,255,0.25);
    border-bottom:  1px solid rgba(255,255,255,0.25);
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 53px;
    text-align: center;
  }
  .page1Title2{
    position: absolute;
    top: 0;
    left: 203px;
    width: 202px;
    height: 53px;
    background: #2A2A2A;
    border-bottom:  1px solid rgba(255,255,255,0.25);
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 53px;
    text-align: center;
  }
  .page1Title2-s{
    position: absolute;
    top: 0;
    left: 203px;
    width: 202px;
    height: 53px;
    background: #233242;
    border-bottom:  1px solid rgba(255,255,255,0.25);
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 53px;
    text-align: center;
  }
  .page1Button{
    position: relative;
    margin-left: 10px;
    margin-bottom: 8px;
    width: 376px;
    height: 64px;
    background-image: url(~@/assets/newHome/目标提取/任务背景.png);
    background-size: 100% 100%;
    border-radius: 8px;
    cursor: pointer;
    transition:background-image 0.3s linear
  }
  .page1Button-s{
    position: relative;
    margin-left: 10px;
    margin-bottom: 8px;
    width: 376px;
    height: 64px;
    background-image: url(~@/assets/newHome/目标提取/任务背景.png);
    background-size: 100% 100%;
    border-radius: 8px;
    cursor: pointer;
    border: 2px solid #0066CC;
  }
  .page1Button:hover{
    background-image: url(~@/assets/newHome/目标提取/任务列表hover.png);
    background-size: 100% 100%;
  }
  .buttonText1{
    position: absolute;
    top: 22px;
    left: 158px;
    width: 170px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }
.vectorLine{
  margin-top: 12px;
  margin-left: 10px;
  margin-bottom: 20px;
  width: 376px;
  height: 1px;
  border-top: 1px solid #979797;
}

.buttonSave {
  margin-bottom: 8px;
  margin-left: 10px;
  width: 376px;
  height: 64px;
  background: #0066CC;
  border-radius: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 64px;
  text-align: center;
  cursor: pointer;
}

.buttonDownload {
  margin-bottom: 8px;
  margin-left: 10px;
  width: 376px;
  height: 64px;
  border-radius: 16px;
  border: 1px solid #FFFFFF;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 64px;
  text-align: center;
  cursor: pointer;
}
.shadow{
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 10001;
  }
  .shadowContent2{
    position: absolute;
    top: calc(50% - 150px);
    left: calc(50% - 400px);
    width: 800px;
    height: 300px;
    background: #2A2A2A;
    border-radius: 16px;
  }
  .shadowTip3Text1{
    position: absolute;
    top: 50px;
    left: 0;
    width: 800px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
  }
  .shadowInput{
    position: absolute;
    top: 123px;
    left: 70px;
    width: 660px;
    height: 54px;
    border-radius: 8px;
    border: 1px solid #FFFFFF;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #FFFFFF;
    line-height:54px;
    padding-left: 20px;
    outline: none;
  }
  .shadowTip3Text2{
    position: absolute;
    top: 179px;
    right: 72px;
    width: 300px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #979797;
    line-height: 20px;
    text-align: right;
  }
  .shadowTip3Text3{
    position: absolute;
    top: 228px;
    left: 343px;
    width: 38px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 22px;
    cursor: pointer;
  }
  .shadowTip3Text3-s{
    position: absolute;
    top: 228px;
    left: 343px;
    width: 38px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
color: #5A5A5A;
    line-height: 22px;
  }
  </style>
  <style scoped>
 .searchImg{
    position: absolute;
    top: 74px;
    left: 20px;
    width: 356px;
    height: 44px;
    background: #3A3A3A;
    border-radius: 22px;
  }
  .searchImgText{
    position: absolute;
    top: 12px;
    left: 22px;
    width:340px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #979797;
    line-height: 20px;
    border: none;
    outline: none;
  }
  .fileContent{
    position: relative;
    width: 405px;
    height: 54px;
    background: transparent;
    cursor: pointer;
  }
  .fileContent:hover{
    background: rgba(0,102,204,0.1);
  }
  .fileContentDrag{
    position: relative;
    width: 405px;
    height: 54px;
    background: transparent;
    cursor: pointer;
  }
  .fileContentDrag:hover{
    background: rgba(0,102,204,0.1);
  }
  .countrySelect2022{
    position: absolute;
    top: 19px;
    left: 13px;
  }
  .fileText1{
    position: absolute;
    top: 5px;
    left: 96px;
    width:250px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 20px;
    white-space: nowrap; /* 防止换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }
  .fileContent-s{
    position: relative;
    width: 405px;
    height: 54px;
    background: rgba(0,102,204,0.1);
    cursor: pointer;
  }

  .fileText2{
    position: absolute;
    top: 32px;
    left: 115px;
    width:200px;
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 17px;
}
.vectorManage{
  position: absolute;
  bottom: 0;
  width: 405px;
height: 52px;
background: #444444;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.vectorManage1{
  position: absolute;
  bottom: 0;
  width: 203px;
height: 52px;
background: #0066CC;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.vectorManage2{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 202px;
height: 51px;
border-top: 1px solid #777777;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.xialaVectorList{
 position: absolute;
 top: 137px;
 width: 405px;
 height: 20px;
 overflow-y: auto;
 overflow-x: hidden;
}
.myData {
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% - 100px);
  width: 200px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  text-align: center;
}
</style>
<style scoped>
.pageContent::-webkit-scrollbar {
  width: 10px;
}

.pageContent::-webkit-scrollbar-thumb {
  height: 500px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  -webkit-box-shadow: inset1px1px0rgba(0, 0, 0, .1);
}

.pageContent::-webkit-scrollbar-thumb:hover {
  background: rgba(76, 76, 76, 1);
}
.xialaVectorList::-webkit-scrollbar {
  width: 10px;
}

.xialaVectorList::-webkit-scrollbar-thumb {
  height: 500px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  -webkit-box-shadow: inset1px1px0rgba(0, 0, 0, .1);
}

.xialaVectorList::-webkit-scrollbar-thumb:hover {
  background: rgba(76, 76, 76, 1);
}
</style>
